import * as MutationsType from "./mutationsType";

export default {
  setShowWelcomeModal({ commit }, toggle) {
    commit(MutationsType.SHOW_WELCOME_MODAL, toggle);
  },
  setTutorial({ commit }, { tutorial }) {
    commit(MutationsType.SET_TUTORIAL, tutorial);
    commit(MutationsType.SHOW_TUTORIAL_MODAL, true);
  },
  setShowTutorialModal({ commit }, toggle) {
    commit(MutationsType.SHOW_TUTORIAL_MODAL, toggle);
    if (!toggle) commit(MutationsType.SET_TUTORIAL, null);
  },
  setShowStepsBanner({ commit }, toggle) {
    commit(MutationsType.SHOW_STEPS_BANNER, toggle);
  },
  setShowFrequentQuestionsDrawer({ commit }, toggle) {
    commit(MutationsType.SHOW_FREQUENT_QUESTIONS_DRAWER, toggle);
  },
};
